import { render, staticRenderFns } from "./OnOffButton.vue?vue&type=template&id=85013918"
import script from "./OnOffButton.vue?vue&type=script&lang=js"
export * from "./OnOffButton.vue?vue&type=script&lang=js"
import style0 from "./OnOffButton.vue?vue&type=style&index=0&id=85013918&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports